/*
 * Module for the Benefit Summary header partial view
*/

rs.module("framework/benefitsummary/benefitsummaryheader",

    [],

    function () {

        //
        // Initialize
        //
        function initialize(jsSelectors) {

            var claimInformation = $.js(jsSelectors.claimInformation, { required: false });
            var relatedBenefits = $.js(jsSelectors.relatedBenefits, { required: false });
            var paymentMethodContainer = $.js(jsSelectors.paymentMethodContainer);

            // show/hide payment method on hover with intent
            claimInformation.hoverIntent({
                handlerOver: function (event) {
                    claimInformation.js(jsSelectors.claimInformationPopup).show();
                },
                handlerOut: function (event) {
                    claimInformation.js(jsSelectors.claimInformationPopup).hide();
                },
                hoverOutDelay: 400
            });

            // show/hide related benefits on hover
            relatedBenefits.hoverIntent({
                handlerOver: function (event) {
                    relatedBenefits.js(jsSelectors.relatedBenefitsPopup).show();
                },
                handlerOut: function (event) {
                    relatedBenefits.js(jsSelectors.relatedBenefitsPopup).hide();
                },
                hoverOutDelay: 400
            });

            // show/hide payment method on hover with intent
            paymentMethodContainer.hoverIntent({
                handlerOver: function (event) {
                    paymentMethodContainer.js(jsSelectors.paymentMethodPopup).show();
                },
                handlerOut: function (event) {
                    paymentMethodContainer.js(jsSelectors.paymentMethodPopup).hide();
                },
                hoverOutDelay: 400
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);